export const items = [
  { key: 'all', label: 'All Interactives' },
  { key: 'Accordion', label: 'Accordion' },
  { key: 'tabs', label: 'Tabs' },
  { key: 'Button', label: 'Button' },
  { key: 'multiplechoice', label: 'Multiple Choice Questions' },
  { key: 'flipcard', label: 'Flip Card' },
  { key: 'imageslider', label: 'Image/Video Slider' },
  { key: 'ClickAndRevealInteractions', label: 'Click & Reveal' },
  { key: 'DragandDrop', label: 'Drag And Drop' },
  { key: 'Hotspot', label: 'Image Hotspot' },
  { key: 'checklist', label: 'Checklist' },
];

export interface InteractiveItem {
  id?: string;
  title: string;
  user_id?: string;
  private?: boolean;
  global?: boolean;
  active?: boolean;
  count?: number;
  library_id?: number;
  library_type?: string;
  obscure_key?: string;
  organization_id?: string;
}
